import { getIndustryName } from './sicCodes';
import { IndustrySummary, IndustrySummaryApiRecord } from '../types/industry';

const toFiniteNumber = (value: unknown, fallback = 0): number => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return fallback;
};

const toIndustryCode = (value: unknown): number | null => {
  const parsed = toFiniteNumber(value, Number.NaN);
  if (!Number.isFinite(parsed)) return null;
  return Math.trunc(parsed);
};

export const mapIndustrySummaryRecords = (raw: unknown): IndustrySummary[] => {
  if (!Array.isArray(raw)) return [];

  return raw
    .map((item): IndustrySummary | null => {
      const record = item as IndustrySummaryApiRecord;
      const industryCode = toIndustryCode(record.industry_code);
      if (industryCode === null) return null;

      const codeForSlug = record.industry_code_original ?? industryCode;
      return {
        industry_code: industryCode,
        codeForSlug,
        name: getIndustryName(String(codeForSlug)),
        count: toFiniteNumber(record.count, 0),
        avgScore: toFiniteNumber(record.avg_score, 0),
        avgTrend: toFiniteNumber(record.avg_trend, 0),
      };
    })
    .filter((industry): industry is IndustrySummary => industry !== null)
    .sort((a, b) => b.count - a.count);
};
